module.exports = __webpack_public_path__ + "img/chevron-up.baae7ed0.svg";